module.exports = __webpack_public_path__ + "media/images/client/email_banner-e922278c38070802b4623c3a897f366d.png";